module.exports = __webpack_public_path__ + "static/media/richmond.984216bd.svg";